module.exports = __webpack_public_path__ + "static/media/org.76b53809.svg";